import { PhotoGalleryComponent } from './photo-gallery/photo-gallery.component';
import { SurveyMeasurementTableComponent } from './survey-measurement-table/survey-measurement-table.component';
import { VisualEventGuidedComponent } from './visual-event-guided/visual-event-guided.component';
import { VisualEventImageViewerComponent } from './visual-event-image-viewer/visual-event-image-viewer.component';
import { VisualEventModalComponent } from './visual-event-modal/visual-event-modal.component';

export const components: any[] = [
  PhotoGalleryComponent,
  SurveyMeasurementTableComponent,
  VisualEventImageViewerComponent,
  VisualEventModalComponent,
  VisualEventGuidedComponent,
];

export * from './photo-gallery/photo-gallery.component';
export * from './survey-measurement-table/survey-measurement-table.component';
export * from './visual-event-modal/visual-event-modal.component';
export * from './visual-event-image-viewer/visual-event-image-viewer.component';
export * from './visual-event-guided/visual-event-guided.component';
